import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ModalAppAvailabilityComponent } from './modal-app-availability.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [ModalAppAvailabilityComponent],
  providers: [],
})
export class ModalAppAvailabilityModule {}
